import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Listbox, Combobox } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
  XCircleIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  LinkIcon,
  ColorSwatchIcon,
  CogIcon,
  MinusIcon,
  PlusIcon,
} from "@heroicons/react/solid";
import axios from "axios";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class InventorytransferCreatemodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      msg: "Source and Destination should not be same",
      logoutRedirect: false,
      success: false,
      redirect: false,
      showmsgforItemNotify: false,
      showmsgforItem: "",
      purchaseorderaccountnamesList: [],
      warehousesList: [],
      warehouseitemList: [],
      icon: "",
      date: "",
      reason: "",
      source_warehouse_id: "",
      destination_warehouse_id: "",
      inventory_transfer_order_items: [
        {
          item_id: 0,
          item_name: "",
          item_description: 0,
          transfer_quantity: 0,
          source_stock: 0,
          cost_rate: 0,
        },
      ],
      queryItem: "",
      error_list: [],
      loader: "animate-pulse",
      overLay: "",
    };
    this.handleInput = this.handleInput.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    this.setLoaderFunction();
    const res = axios
      .get("public/api/warehouses", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ warehousesList: res.data.warehouses });
        this.closeLoaderFuncion();
      });
    setTimeout(
      function () {
        //Start the timer
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
    this.closeLoaderFuncion();
  }

  handleInput = (e) => {
    const token = localStorage.getItem("token");

    this.setLoaderFunction();

    if (e.target.name == "source_warehouse_id") {
      if (this.state.destination_warehouse_id != e.target.value) {
        this.setLoaderFunction();
        const res6 = axios
          .get("public/api/items/for/warehouse/" + e.target.value, {
            headers: {
              authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          })
          .then((res6) => {
            this.setState({ warehouseitemList: res6.data.warehouse_items });
            this.closeLoaderFuncion();
          });
      } else {
        this.setState({ showmsg: true });
        this.setState({
          source_warehouse_id: "",
        });
        this.setState({
          destination_warehouse_id: "",
        });
        setTimeout(
          function () {
            //Start the timer
            this.setState({ showmsg: false }); //After 1 second, set render to true
          }.bind(this),
          2000
        );
      }
    }
    if (e.target.name == "destination_warehouse_id") {
      if (this.state.source_warehouse_id != e.target.value) {
      } else {
        this.setState({ showmsg: true });
        this.setState({
          source_warehouse_id: "",
        });
        this.setState({
          destination_warehouse_id: "",
        });
        setTimeout(
          function () {
            //Start the timer
            this.setState({ showmsg: false }); //After 1 second, set render to true
          }.bind(this),
          2000
        );
      }
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
    this.closeLoaderFuncion();
  };

  addinventoryItem = (e) => {
    this.setState({
      inventory_transfer_order_items:
        this.state.inventory_transfer_order_items.concat([
          {
            item_id: 0,
            item_name: "",
            item_description: 0,
            transfer_quantity: 0,
            source_stock: 0,
            cost_rate: 0,
          },
        ]),
    });
  };

  handleInputnewquantityonhand = (InvoiceItemIndex) => (e) => {
    this.state.inventory_transfer_order_items[
      InvoiceItemIndex
    ].transfer_quantity = e.target.value;

    this.setState({
      inventory_transfer_order_items: this.state.inventory_transfer_order_items,
    });
  };

  deleteinventoryItem = (inventoryindex) => async (e) => {
    this.state.inventory_transfer_order_items =
      this.state.inventory_transfer_order_items.filter(
        (s, sidx) => inventoryindex !== sidx
      );

    this.setState({
      inventory_transfer_order_items: this.state.inventory_transfer_order_items,
    });
  };

  handleInputwarehouseF = (e) => {
    this.props.handleInputwarehouseA(e);
  };

  saveItem = async (e) => {
    e.preventDefault();
    this.setLoaderFunction();
    if (this.state.inventory_transfer_order_items.length > 0) {
      var token = localStorage.getItem("token");
      const headers = {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      };

      const res = await axios.post(
        "public/api/inventory/transfer/order/store",
        this.state,
        {
          headers,
        }
      );

      if (res.data.success) {
        // this.setState({ showmsg: true });
        this.handleInputwarehouseF(res.data.success);
        setTimeout(
          function () {
            //Start the timer
            this.setState({ redirect: true }); //After 1 second, set render to true
          }.bind(this),
          1000
        );
        this.closeLoaderFuncion();
      } else {
        this.state.error_list = res.data.data;
        this.setState({ error_list: this.state.error_list });
        
        this.closeLoaderFuncion();
        //this.setState({ show: true })
      }
    }
    this.closeLoaderFuncion();
    if (this.state.inventory_transfer_order_items.length === 0) {
      this.setState({ showmsgforItemNotify: true });
      this.setState({
        showmsgforItem: "Item Details cannot be empty",
      });
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };
  //Logout function
  handleInputtwo = (e) => {
    this.setState({
      queryItem: e.target.value,
    });
  };
  handleInputSelectItem = (InvoiceItemIndex) => (e) => {
    console.log(e, InvoiceItemIndex);
    this.state.inventory_transfer_order_items[InvoiceItemIndex].item_id = e.id;
    this.state.inventory_transfer_order_items[InvoiceItemIndex].item_name =
      e.name;
    this.state.inventory_transfer_order_items[InvoiceItemIndex].source_stock =
      e.opening_stock;

    this.setState({
      inventory_transfer_order_items: this.state.inventory_transfer_order_items,
    });
  };

  render() {
    const filteredItem =
      this.state.queryItem === ""
        ? this.state.warehouseitemList
        : this.state.warehouseitemList.filter((warehouseitemList) => {
            return warehouseitemList.name
              .toLowerCase()
              .includes(this.state.queryItem.toLowerCase());
          });

    const TableHeaderqty = () => (
      <tr className="divide-x divide-gray-200">
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
            Item Details
          </span>
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Current Availability
        </th>

        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Transfer Quantity
        </th>
        <th
          scope="col"
          className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        >
          Delete
        </th>
      </tr>
    );

    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div className={this.state.overLay} aria-hidden="true" />
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                Inventory Transfer Order
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="transaction_series_number"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Transfer Order#:
                              </label>
                              <input
                                type="text"
                                readOnly
                                name="transaction_series_number"
                                onChange={this.handleInput}
                                id="transaction_series_number"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="transaction_series_number-error"
                              >
                                {this.state.error_list.transaction_series_number
                                  ? this.state.error_list
                                      .transaction_series_number[0]
                                  : ""}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="date"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Date
                                </span>
                              </label>
                              <input
                                type="date"
                                name="date"
                                onChange={this.handleInput}
                                id="date"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="date-error"
                              >
                                {this.state.error_list.date}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="reason"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Reason
                              </label>
                              <input
                                type="text"
                                name="reason"
                                onChange={this.handleInput}
                                id="reason"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="reason-error"
                              >
                                {" "}
                                {this.state.error_list.reason
                                  ? this.state.error_list.reason[0]
                                  : ""}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="source_warehouse_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Source Warehouse
                                </span>
                              </label>
                              <select
                                id="source_warehouse_id"
                                name="source_warehouse_id"
                                onChange={this.handleInput}
                                value={this.state.source_warehouse_id}
                                autoComplete="source_warehouse_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.warehousesList.map((number) => (
                                  <option value={number.id}>
                                    {number.warehouse_name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="source_warehouse_id-error"
                              >
                                {this.state.error_list.source_warehouse_id
                                  ? this.state.error_list.source_warehouse_id
                                  : ""}
                              </p>
                            </div>
                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="destination_warehouse_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Destination Warehouse
                                </span>
                              </label>
                              <select
                                id="destination_warehouse_id"
                                name="destination_warehouse_id"
                                onChange={this.handleInput}
                                value={this.state.destination_warehouse_id}
                                autoComplete="destination_warehouse_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.warehousesList.map((number) => (
                                  <option value={number.id}>
                                    {number.warehouse_name}
                                  </option>
                                ))}
                              </select>
                              <p className="mt-2 text-sm text-red-600">
                                {this.state.error_list.destination_warehouse_id
                                  ? this.state.error_list
                                      .destination_warehouse_id
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="px-4 py-5 overflow-x-auto  bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <table className="min-w-full divide-y divide-gray-300">
                              <thead className="bg-gray-50">
                                <TableHeaderqty />
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.inventory_transfer_order_items.map(
                                  (Itemsi, index) => (
                                    <tr
                                      key={index}
                                      className="divide-x divide-gray-200"
                                    >
                                      <td className="">
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                          <Combobox
                                            as="div"
                                            value={Itemsi}
                                            onChange={this.handleInputSelectItem(
                                              index
                                            )}
                                          >
                                            <Combobox.Label className="block text-sm font-medium text-gray-700"></Combobox.Label>
                                            <div className="relative mt-1">
                                              <Combobox.Input
                                                className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                onChange={this.handleInputtwo}
                                                displayValue={(Items) =>
                                                  typeof Items.item_name !==
                                                    "undefined" &&
                                                  Items.item_name != null
                                                    ? Items.item_name
                                                    : ""
                                                }
                                              />
                                              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                <SelectorIcon
                                                  className="h-5 w-5 text-gray-400"
                                                  aria-hidden="true"
                                                />
                                              </Combobox.Button>

                                              {filteredItem.length > 0 && (
                                                <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                  {filteredItem.map(
                                                    (itemLine) => (
                                                      <Combobox.Option
                                                        key={itemLine.id_crypt}
                                                        value={itemLine}
                                                        className={({
                                                          active,
                                                        }) =>
                                                          classNames(
                                                            "relative cursor-default select-none py-2 pl-3 pr-9",
                                                            active
                                                              ? "bg-indigo-600 text-white"
                                                              : "text-gray-900"
                                                          )
                                                        }
                                                      >
                                                        {({
                                                          active,
                                                          selected,
                                                        }) => (
                                                          <>
                                                            <span
                                                              className={classNames(
                                                                "block truncate",
                                                                selected &&
                                                                  "font-semibold"
                                                              )}
                                                            >
                                                              {itemLine.name}
                                                            </span>

                                                            {selected && (
                                                              <span
                                                                className={classNames(
                                                                  "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                  active
                                                                    ? "text-white"
                                                                    : "text-indigo-600"
                                                                )}
                                                              >
                                                                <CheckIcon
                                                                  className="h-5 w-5"
                                                                  aria-hidden="true"
                                                                />
                                                              </span>
                                                            )}
                                                          </>
                                                        )}
                                                      </Combobox.Option>
                                                    )
                                                  )}
                                                </Combobox.Options>
                                              )}
                                            </div>
                                          </Combobox>
                                          <p
                                            className="mt-2 text-sm text-red-600"
                                            id="email-error"
                                          ></p>
                                        </div>
                                      </td>
                                      <td>
                                        {" "}
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-1  ">
                                          <p className="text-sm">
                                            Source Stock: {Itemsi.source_stock}
                                          </p>
                                        </div>
                                      </td>
                                      <td>
                                        {" "}
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-1 ">
                                          <input
                                            type="number"
                                            name="transfer_quantity"
                                            onChange={this.handleInputnewquantityonhand(
                                              index
                                            )}
                                            id="transfer_quantity"
                                            value={Itemsi.transfer_quantity}
                                            autoComplete="address-level2"
                                            className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                          />
                                          <p
                                            className="mt-2 text-sm text-red-600"
                                            id="email-error"
                                          >
                                            {
                                              this.state.error_list
                                                .transfer_quantity
                                            }
                                          </p>
                                        </div>
                                      </td>

                                      <td>
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                          <button
                                            type="button"
                                            onClick={this.deleteinventoryItem(
                                              index
                                            )}
                                            className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                          >
                                            <MinusIcon
                                              className="h-5 w-5"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                              <tfoot>
                                <tr className="divide-x divide-gray-200">
                                  <td>
                                    <button
                                      type="button"
                                      className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                      onClick={this.addinventoryItem}
                                    >
                                      <PlusIcon
                                        className="-ml-1 mr-2 h-5 w-5"
                                        aria-hidden="true"
                                      />
                                      Add
                                    </button>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <XCircleIcon
                        className="h-6 w-6 text-red-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.msg}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*stock Message*/}

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsgforItemNotify}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <XCircleIcon
                        className="h-6 w-6 text-red-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {this.state.showmsgforItem}
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({
                            showmsgforItemNotify: false,
                            showmsgforItem: "",
                          });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*stock Message*/}
      </>
    );
  }
}

export default InventorytransferCreatemodal;
